import React from "react"
import { useTranslation } from "react-i18next"
import PoweredByAeraFooter from "../../../images/powered-by-aera.svg"
import "./FormFooter.scss"
import cn from "classnames"
interface IFormFooterProps {
    className?: string
}

const FormFooter = ({ className }: IFormFooterProps) => {
    const { t } = useTranslation()
    return (
        <div className={cn("swiipe-form-footer form-footer mb-2 mt-5", className)}>
            <p className="text-center">
                <img src={PoweredByAeraFooter} className="powered-by-aera" />
            </p>
        </div>
    )
}

export default FormFooter
